export type GenerationModeId = "fast" | "professional" | "creative";

export const marketingNavigation = [
  { href: "#create", label: "灵感起笔", purpose: "开始创作" },
  { href: "#templates", label: "风格拾光", purpose: "模板预览" },
  { href: "#cases", label: "佳作长廊", purpose: "场景示例" },
  { href: "#editor", label: "精雕细琢", purpose: "Windows 编辑器预览" },
  { href: "#enterprise", label: "携手成章", purpose: "团队方案" },
] as const;

// These labels do not change the canonical mode IDs or the bounded trial.
export const generationModes = [
  { id: "fast", title: "灵光一闪", hint: "快速起稿" },
  { id: "professional", title: "深思成篇", hint: "结构优先" },
  { id: "creative", title: "天马行空", hint: "视觉探索" },
] as const;

export const workflowSteps = [
  { order: "01", title: "理解资料" },
  { order: "02", title: "构建故事" },
  { order: "03", title: "生成页面" },
  { order: "04", title: "检查优化" },
  { order: "05", title: "编辑交付" },
] as const;

export const supportedFiles = ["PDF", "Word", "Excel", "Markdown", "PPTX"] as const;
